let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5BkfB")).then(() => parcelRequire('6eQg4'));